// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MyInquirySurvey_wrapper__K8BrK","section":"MyInquirySurvey_section__uifDe","title":"MyInquirySurvey_title__sTel3","submit":"MyInquirySurvey_submit__Hg34n"};